import React from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { isMobile } from 'react-device-detect';
import { accountService, alertService } from '../_services';
import { useTranslation } from 'react-i18next';

import { FcGoogle } from "react-icons/fc";
import { FaFacebook, FaPhoneAlt } from "react-icons/fa";

function Login({ history, location }) {
    const { t } = useTranslation();

    const initialValues = {
        email: '',
        password: ''
    };

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email(t('emailIsInvalid'))
            .required(t('emailIsRequired')),
        password: Yup.string().required(t('passwordIsRequired'))

    });

    function onSubmit({ email, password }, { setSubmitting }) {
        alertService.clear();
        accountService.login(email, password)
            .then(() => {
                const { from } = location.state || { from: { pathname: "/" } };
                history.push(from);
            })
            .catch(error => {
                setSubmitting(false);
                alertService.error(error);
            });
    }

    function loginWithGoogle(e) {
        accountService.loginWithGoogle()
            .then(() => {
                const { from } = location.state || { from: { pathname: "/" } };
                history.push(from);
            })
            .catch(error => {
                alertService.error(error);
            });;
    }

    function loginWithPhone() {
        window.TRYBOOK.phoneAuth = true;
        history.push("/account/verify-mobile");
    }

    function loginWithFacebook() {
        accountService.loginWithFacebook()
            .then(() => {
                const { from } = location.state || { from: { pathname: "/" } };
                history.push(from);
            })
            .catch(error => {
                alertService.error(error);
            });;
    }

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ errors, touched, isSubmitting }) => (
                <Form>
                    <h3 className="card-header">{t('bookLogin')}</h3>
                    <div className="card-body">                        
                        <div className="form-group">
                            <label>{t('Email')}</label>
                            <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                            <ErrorMessage name="email" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group">
                            <label>{t('Password')}</label>
                            <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                            <ErrorMessage name="password" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-row">
                            <div className="form-group col-12 col-sm-6">
                                <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                                    {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                    {t('login')}
                                </button>
                                <Link to="register" className="btn btn-link">{t('register')}</Link>
                            </div>
                            <div className={`form-group col-12 col-sm-6 ${isMobile ? '' : 'text-right'} `}>
                                <Link to="forgot-password" className="btn btn-link pr-0">{t('forgotPassword')}</Link>
                            </div>
                        </div>
                        <div className="form-row mt-3">
                            <div className="form-group col-12 ">
                                <button type="button" disabled={isSubmitting} onClick={loginWithGoogle} className="btn btn-outline-primary">
                                    {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                    <FcGoogle className='border-0 mr-2 display-5' />
                                    {t('continueWithGoogle')}
                                </button>
                            </div>
                            <div className="form-group col-12">
                                <button type="button" disabled={isSubmitting} onClick={loginWithPhone} className="btn btn-outline-primary">
                                    {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                    <FaPhoneAlt className='border-0 mr-2 display-5' />
                                    {t('continueWithPhone')}
                                </button>                                
                            </div>
                            <div className="form-group col-12 d-none">
                                <button type="button" disabled={isSubmitting} onClick={loginWithFacebook} className="btn btn-outline-primary">
                                    {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                    <FaFacebook className='border-0 mr-2 display-5' />
                                    {t('continueWithFacebook')}
                                </button>
                            </div>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    )
}

export { Login }; 